import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Coins } from 'lucide-react';
import { toast } from 'sonner';
import { useCredits } from '../lib/hooks';
import TopBar from '../components/TopBar';
import BottomNav from '../components/BottomNav';

const PaymentSuccess = ({ profile, setProfile }) => {
  const navigate = useNavigate();
  const { credits, refetch } = useCredits(profile);

  useEffect(() => {
    // Refetch credits to show updated balance
    refetch();
    
    // BIG SUCCESS TOAST on page load
    setTimeout(() => {
      toast.success('Payment Successful!', {
        description: `Credits have been added to your account`,
        duration: 5000,
      });
    }, 300);

    // Auto-redirect to dashboard after 4 seconds
    const redirectTimer = setTimeout(() => {
      navigate('/dashboard');
    }, 4000);

    return () => clearTimeout(redirectTimer);
  }, []);

  return (
    <div className="min-h-screen-safe pb-nav md:pb-0">
      <TopBar profile={profile} setProfile={setProfile} />

      <div className="flex items-center justify-center px-4 py-12 min-h-[80vh]">
        <Card className="max-w-md w-full text-center border-2 border-green-500 shadow-2xl">
          <CardContent className="p-8">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce">
              <CheckCircle className="text-green-600" size={48} />
            </div>
            
            <h1 className="font-heading text-3xl font-bold mb-2 text-green-600">Payment Successful!</h1>
            <p className="text-muted-foreground mb-6 text-lg">
              Your credits have been added to your account
            </p>

            <div className="bg-gradient-to-r from-primary/10 to-primary/5 rounded-2xl p-6 mb-6">
              <div className="flex items-center justify-center gap-3 text-primary">
                <Coins size={32} />
                <span className="text-5xl font-bold">
                  {credits.balance}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mt-2">
                Available Credits
              </p>
            </div>

            <p className="text-sm text-muted-foreground mb-4">
              Redirecting to dashboard in a moment...
            </p>

            <Button
              className="w-full rounded-xl"
              size="lg"
              onClick={() => navigate('/dashboard')}
              data-testid="go-to-dashboard-btn"
            >
              Go to Dashboard Now
            </Button>
          </CardContent>
        </Card>
      </div>

      <BottomNav />
    </div>
  );
};

export default PaymentSuccess;
